import React, { useContext, useState } from 'react';
import EditIcon from '@mui/icons-material/Edit';
import MailOutlineIcon from '@mui/icons-material/MailOutline';
import { 
  Alert,
  Box,
  Button,
  Collapse,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Grid,
  IconButton,
  Typography,
  TextField, 
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

import { useAuth } from '../../../Contexts/AuthContext';
import { useSimulation } from '../../../Contexts/SimulationContext';
import { editUser } from '../../../Helpers/dataApi';
import SimulationControls from '../../../Components/SimulationControls/SimulationControls';

const AccountProfile = () => {

  const auth = useAuth();
  const simulation = useSimulation();

  const{
    activeUser
  } = auth;

  const [userInfo, setUserInfo] = useState({
    firstName: activeUser.firstName,
    lastName: activeUser.lastName,
    email: activeUser.email,
  });
  const [showConfirm, setShowConfirm] = useState({
    userInfo: false,
    email: false,
  });
  const [errors, setErrors] = useState({
    firstName: false,
    lastName: false,
    userInfoSubmit: false,
    email: false,
  });
  const [errorMessage, setErrorMessage] = useState('');
  const [success, setSuccess] = useState({
    userInfoSubmit: false,
  });
  const [successMessage, setSuccessMessage] = useState('');

  const handleEditConfirm = () => {
    // console.log('confirm edit');
    const userData = {
      first_name: userInfo.firstName,
      last_name: userInfo.lastName,
      email: activeUser.email,
      user_type: activeUser.userType,
      organization_id: activeUser.organization.id,
      id: activeUser.id,
    }
    editUser(userData, activeUser.accessToken)
    .then((response) => {
      if(response.status === 200){
        handleUserInfoSuccess();
      }
      else{
        setSuccess({...success, userInfoSubmit: false});
        setErrors({
          ...errors,
          userInfoSubmit: true,
        });
        setErrorMessage(response.message);
      }
    })
    .catch((err) => {
      console.error(err);
      setSuccess(false);
      setErrors({
        ...errors,
        userInfoSubmit: true,
      });
      setErrorMessage(err);
    });
  }

  const handleUserInfoSuccess = () => {
    // console.log("success");
    setErrors({
      firstName: false,
      lastName: false,
      email: false,
    });
    setSuccess({...success, userInfoSubmit: true});
    setSuccessMessage("Information updated successfully");
    setShowConfirm({...showConfirm, userInfo: false});
    // Update the cookie/context so the header reflects the new name immediately
    auth.updateActiveUser({ firstName: userInfo.firstName, lastName: userInfo.lastName });
    setTimeout(() => {
      setSuccess({...success, userInfo: false});
    }, "10000");
  }

  const handleEmailConfirm = () => {
    // console.log('confirm edit');
  }

  return (
    <>
      <Box
        component={'div'}
        sx={{
          display: 'flex',
          flexWrap: 'wrap',
          paddingTop: '16px',
        }}
      >
        <Grid
          container
          spacing={2}
          sx={{
            marginTop: '0',
            width: '100%',
          }}
        >
          <Grid
            item
            xs={12}
          >
            <Typography
              align='left'
              sx={{
                fontSize: '1.2rem',
                fontWeight: 'bold',
                width: '100%'
              }}
            >
              Edit account information
            </Typography>
          </Grid>
          <Grid 
            item
            sx={{
              display: 'flex',
              justifyContent: 'flex-start',
            }}
            xs={4}
          >
            <TextField 
              id="firstName" 
              label="First Name"
              onChange={(event) => {
                setUserInfo({...userInfo, firstName: event.target.value});
              }}
              sx={{
                width: '100%',
              }}
              value={userInfo.firstName}
              variant="outlined"
            />
          </Grid>
          <Grid 
            item 
            sx={{
              display: 'flex',
              justifyContent: 'flex-start',
            }}
            xs={4}
          >
            <TextField 
              id="lastName" 
              label="Last Name"
              onChange={(event) => {
                setUserInfo({...userInfo, lastName: event.target.value});
              }}
              sx={{
                width: '100%',
              }}
              value={userInfo.lastName}
              variant="outlined" 
            />
          </Grid>
          <Grid 
            item 
            xs={12}
          >
            <Collapse
              in={!showConfirm.userInfo}
            >
              <Button
                color={"success"}
                startIcon={<EditIcon />}
                variant="contained"
                onClick={() => setShowConfirm({...showConfirm, userInfo: true})}
                sx={{
                  display: 'flex'
                }}
              >
                Edit Information
              </Button>
            </Collapse>
            <Collapse
              in={showConfirm.userInfo}
            >
              <Button
                onClick={() => setShowConfirm({...showConfirm, userInfo: false})}
                sx={{
                  marginRight: '15px',
                }}
                variant="text"
              >
                Cancel
              </Button>
              <Button
                color={'success'}
                onClick={() => handleEditConfirm()}
                variant="outlined"
              >
                Edit
              </Button>
            </Collapse>
          </Grid>

        <Grid
          item
          xs={8}
        >
          <Collapse 
            in={success.userInfoSubmit}
          >
            <Alert
              action={
                <IconButton
                  aria-label="close"
                  color="inherit"
                  size="small"
                  onClick={() => {
                    setSuccess({...success, userInfo: false})
                  }}
                >
                  <CloseIcon fontSize="inherit" />
                </IconButton>
              }
              sx={{ mb: 2 }}
            >
              <Typography
                align='left'
                sx={{
                  fontSize: '1rem',
                  width: '100%'
                }}
              >
                {successMessage}
              </Typography>
            </Alert>
          </Collapse>
          <Collapse
            in={errors.userInfoSubmit}
          >
            <Alert
              action={
                <IconButton
                  aria-label="close"
                  color="inherit"
                  size="small"
                  onClick={() => {
                    setErrors({...errors, userInfoSubmit: false});
                    setShowConfirm({...showConfirm, userInfo: false});
                  }}
                >
                  <CloseIcon fontSize="inherit" />
                </IconButton>
              }
              severity="error"
              sx={{ mb: 2 }}
            >
              <Typography
                align='left'
                sx={{
                  fontSize: '1rem',
                  width: '100%'
                }}
              >
                Account edit failed. Please refresh the page and try again.
                <br/>
                <b>ERROR:</b> {errorMessage}
                <br/><br/>
                If the problem persists, please contact BridgeFirst support at <a href={`mailto:support@bridgefirstforecasting.com?subject=Error editing account info&body=ERROR: ${errorMessage}`}>support@bridgefirstforecasting.com</a>
              </Typography>
            </Alert>
          </Collapse>
        </Grid>
          {/* Simulation Controls - Only for Super Users */}
          {activeUser.userType === 0 && (
            <>
              <Grid
                item
                xs={12}
                sx={{
                  marginTop: '40px',
                  paddingTop: '40px',
                  borderTop: '1px solid #e0e0e0',
                }}
              >
                <Typography
                  align='left'
                  sx={{
                    fontSize: '1.2rem',
                    fontWeight: 'bold',
                    width: '100%',
                    marginBottom: '8px',
                  }}
                >
                  Super User Simulation Mode
                </Typography>
                <Typography
                  align='left'
                  sx={{
                    fontSize: '0.95rem',
                    color: '#666',
                    width: '100%',
                    marginBottom: '16px',
                  }}
                >
                  As a Super User, you can temporarily simulate different roles and organizations to test permissions and access control throughout the application. This helps you verify what users with different roles can see and do without needing multiple test accounts.
                </Typography>
                <Alert severity="info" sx={{ marginBottom: '24px' }}>
                  <Typography variant="body2">
                    <strong>How it works:</strong> Select a role and/or organization below to simulate. The entire application will update to reflect the simulated permissions. Your actual role remains unchanged - this is only for testing. Click "Exit Simulation" in the warning banner to return to your normal Super User view.
                  </Typography>
                </Alert>
              </Grid>
              
              <Grid
                item
                xs={12}
              >
                <SimulationControls />
              </Grid>
              
              {simulation.isSimulating && (
                <Grid
                  item
                  xs={12}
                  sx={{
                    marginTop: '16px',
                  }}
                >
                  <Alert severity="warning">
                    <Typography variant="body2">
                      <strong>Simulation Active:</strong> You are currently viewing the application as a simulated user. Data will automatically refresh when you change simulation settings. Look for the warning banner at the top of pages to exit simulation mode.
                    </Typography>
                  </Alert>
                </Grid>
              )}
            </>
          )}
          {/* <Grid 
            item 
            sx={{
              marginTop: '30px',
            }}
            xs={12}
          >
            <Typography
              align='left'
              sx={{
                fontSize: '1.2rem',
                fontWeight: 'bold',
                width: '100%'
              }}
            >
              Change account email address
            </Typography>
          </Grid>
          <Grid 
            item 
            xs={12}
          >
            <TextField
              id="email"
              label="Email"
              onChange={(event) => {
                setUserInfo({...userInfo, email: event.target.value});
              }}
              sx={{
                display: 'flex',
                width: '350px',
              }}
              value={userInfo.email}
              variant="outlined"
            />
          </Grid>
          <Grid 
            item
            xs={12}
          >
            <Button
              color={"success"}
              startIcon={<MailOutlineIcon />}
              variant="contained"
              onClick={() => setShowConfirm({...showConfirm, email: true})}
              sx={{
                display: 'flex',
              }}
            >
              Edit Email
            </Button>
          </Grid> */}
        </Grid>
      </Box>
      <Dialog
        onClose={() => setShowConfirm({...showConfirm, email: false})}
        open={showConfirm.email}
      >
        <DialogTitle>Confirm new email</DialogTitle>
        <DialogContent>
            <DialogContentText>
              Please confirm you wish to change your account email to <b>{userInfo.email}</b>. If you continue <b>{userInfo.email}</b> will be your new login email.
            </DialogContentText>
            <br/>
            <DialogContentText>
              After confirmation, you will be logged out and will need to log back in with your new email.
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button
              color={"success"}
              onClick={() => handleEmailConfirm()}
            >
              Confirm
            </Button>
            <Button 
              color={"error"}
              onClick={() => setShowConfirm({...showConfirm, email: false})}
            >
              Cancel
            </Button>
          </DialogActions>
      </Dialog> 
    </>
  );
};

export default AccountProfile;